<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App"
};
</script>
<style>
.van-dropdown-menu__bar {
  margin: 0px !important;
  height: 40px !important;
  width: 100%;
  background-color: transparent !important;
  box-shadow: none !important;
}
.van-uploader__upload {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue